import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import "./fonts.css";

import { AuthProvider } from "contexts/AuthContext";
import { QueryClient, QueryClientProvider } from "react-query";

import { I18nRouter } from "./router/I18nRouter";
import { TakebackQueueProvider } from "./takeback-queue/TakebackQueueProvider";
import { FloodlightProvider } from "./providers/FloodlightProvider";

const queryClient = new QueryClient();

const App = () => {
  const { i18n } = useTranslation();

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <FloodlightProvider>
          <Helmet>
            <html lang={i18n.language} />
            <style type="text/css">
              {`
                .cky-consent-container a, .cky-modal a { color: #1863dc !important; text-decoration: underline; }
                .t-and-cs * { all: revert }
                .t-and-cs ol { list-style-type: none }
              `}
            </style>
            <link
              rel="icon"
              href="https://legobricktakeback.com/fav-icons/favicon.ico"
              type="image/x-icon"
            />
          </Helmet>
          <TakebackQueueProvider>
            <I18nRouter />
          </TakebackQueueProvider>
        </FloodlightProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
};

export default App;
